'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _videoPlayer = require('video-player');

var _videoPlayer2 = _interopRequireDefault(_videoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWrapperFabric(element) {
  function Wrapper(config) {
    var _this = this;

    this._node = document.createElement('div');

    this._element = _react2.default.cloneElement(element, {
      eventEmitter: config.eventEmitter,
      engine: config.engine
    });

    _reactDom2.default.render(this._element, this._node);

    return {
      passNewProps: function passNewProps(newProps) {
        _this._element = _react2.default.cloneElement(_this._element, newProps);
        _reactDom2.default.render(_this._element, _this._node);
      },
      getNode: function getNode() {
        return _this._node;
      },
      destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(_this._node);
        _this._node.remove();
        delete _this._node;
        delete _this._element;
      }
    };
  }

  return Wrapper;
}

var VideoPlayerWrapper = function (_React$Component) {
  (0, _inherits3.default)(VideoPlayerWrapper, _React$Component);

  function VideoPlayerWrapper(props) {
    (0, _classCallCheck3.default)(this, VideoPlayerWrapper);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (VideoPlayerWrapper.__proto__ || (0, _getPrototypeOf2.default)(VideoPlayerWrapper)).call(this, props));

    _this2.callProperPlaybackCallback = _this2.callProperPlaybackCallback.bind(_this2);

    _this2.createPlayerInstance(props);
    _this2.attachCallbacks(props);
    return _this2;
  }

  (0, _createClass3.default)(VideoPlayerWrapper, [{
    key: 'createPlayerInstance',
    value: function createPlayerInstance(props) {
      var sizeConfig = (0, _pick3.default)(props, ['width', 'height']);
      var playbackConfig = (0, _pick3.default)(props, ['autoplay', 'muted', 'volume', 'preload', 'loop']);
      var posterConfig = (0, _pick3.default)(props, ['poster']);
      var controlsConfig = (0, _pick3.default)(props, ['controls']);
      var customUI = {};
      var overlayConfig = posterConfig.poster ? { poster: posterConfig.poster } : false;
      var children = props.children;

      if (children) {
        if ((0, _isArray3.default)(children)) {
          children.forEach(function (child, key) {
            customUI[child.type.name + key] = getWrapperFabric(child);
          });
        } else {
          customUI[children.type.name] = getWrapperFabric(children);
        }
      }

      this.player = new _videoPlayer2.default.Player((0, _extends3.default)({}, playbackConfig, {
        size: sizeConfig,
        overlay: overlayConfig,
        controls: controlsConfig,
        src: props.src,
        customUI: customUI
      }));

      if (!props.paused) {
        this.player.play();
      }
    }
  }, {
    key: 'attachCallbacks',
    value: function attachCallbacks(props) {
      this.player.on(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.on(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.on(_videoPlayer.UI_EVENTS.FULLSCREEN_ENTER_TRIGGERED, props.onFullScreenEnter);
      this.player.on(_videoPlayer.UI_EVENTS.FULLSCREEN_EXIT_TRIGGERED, props.onFullScreenExit);
      this.player.on(_videoPlayer.VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.callProperPlaybackCallback);
    }
  }, {
    key: 'unAttachCallbacks',
    value: function unAttachCallbacks() {
      var props = this.props;


      this.player.off(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.off(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.off(_videoPlayer.UI_EVENTS.FULLSCREEN_ENTER_TRIGGERED, props.onFullScreenEnter);
      this.player.off(_videoPlayer.UI_EVENTS.FULLSCREEN_EXIT_TRIGGERED, props.onFullScreenExit);
      this.player.off(_videoPlayer.VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.callProperPlaybackCallback);
    }
  }, {
    key: 'callProperPlaybackCallback',
    value: function callProperPlaybackCallback(status) {
      if (status === _videoPlayer.PLAYBACK_STATUSES.PLAYING || status === _videoPlayer.PLAYBACK_STATUSES.PLAYING_BUFFERING) {
        this.props.onPlay();
      }

      if (status === _videoPlayer.PLAYBACK_STATUSES.PAUSED || status === _videoPlayer.PLAYBACK_STATUSES.PAUSED_BUFFERING) {
        this.props.onPause();
      }

      if (status === _videoPlayer.PLAYBACK_STATUSES.ENDED) {
        this.props.onEnd();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updatePlayerBasicProps(nextProps);
      this.updatePlaybackStatus(nextProps);
      this.updatePlayerUI(nextProps);
      this.updateCustomUI(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unAttachCallbacks();
    }
  }, {
    key: 'updateCustomUI',
    value: function updateCustomUI(_ref) {
      var _this3 = this;

      var children = _ref.children;

      if (!children) {
        return;
      }

      if ((0, _isArray3.default)(children)) {
        children.forEach(function (child, key) {
          _this3.player.ui.customComponents[child.type.name + key].passNewProps(child.props);
        });
      } else {
        this.player.ui.customComponents[children.type.name].passNewProps(children.props);
      }
    }
  }, {
    key: 'updatePlaybackStatus',
    value: function updatePlaybackStatus(_ref2) {
      var paused = _ref2.paused;

      if (paused) {
        this.player.pause();
      } else {
        this.player.play();
      }
    }
  }, {
    key: 'updatePlayerBasicProps',
    value: function updatePlayerBasicProps(_ref3) {
      var src = _ref3.src,
          autoplay = _ref3.autoplay,
          muted = _ref3.muted,
          loop = _ref3.loop,
          volume = _ref3.volume,
          preload = _ref3.preload;

      if (!(0, _isEqual3.default)(this.props.src, src)) {
        this.player.setSrc(src);
      }

      if (this.props.autoplay !== autoplay) {
        this.player.setAutoplay(autoplay);
      }

      if (this.props.muted !== muted) {
        this.player.setMute(muted);
      }

      if (this.props.loop !== loop) {
        this.player.setLoop(loop);
      }

      if (this.props.volume !== volume) {
        this.player.setVolume(volume);
      }

      if (this.props.preload !== preload) {
        this.player.setPreload(preload);
      }
    }
  }, {
    key: 'updatePlayerUI',
    value: function updatePlayerUI(_ref4) {
      var width = _ref4.width,
          height = _ref4.height,
          poster = _ref4.poster;

      if (this.props.width !== width) {
        this.player.ui.setWidth(width);
      }

      if (this.props.height !== height) {
        this.player.ui.setHeight(height);
      }

      if (this.props.poster !== poster) {
        this.player.ui.overlay.setBackgroundSrc(poster);
      }
    }
  }, {
    key: 'appendPlayerNode',
    value: function appendPlayerNode(node) {
      if (!node) {
        return false;
      }

      node.appendChild(this.player.node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var wrapperElement = this.props.wrapperElement;


      if (wrapperElement) {
        return _react2.default.cloneElement(wrapperElement, {
          ref: function ref(node) {
            return _this4.appendPlayerNode(node);
          }
        });
      }

      return _react2.default.createElement('div', { ref: function ref(node) {
          return _this4.appendPlayerNode(node);
        } });
    }
  }]);
  return VideoPlayerWrapper;
}(_react2.default.Component);

VideoPlayerWrapper.propTypes = {
  width: _react2.default.PropTypes.number,
  height: _react2.default.PropTypes.number,
  src: _react2.default.PropTypes.array,

  autoplay: _react2.default.PropTypes.bool,
  muted: _react2.default.PropTypes.bool,
  loop: _react2.default.PropTypes.bool,
  volume: _react2.default.PropTypes.number,
  preload: _react2.default.PropTypes.string,

  poster: _react2.default.PropTypes.string,

  onPlay: _react2.default.PropTypes.func,
  onPause: _react2.default.PropTypes.func,
  onEnd: _react2.default.PropTypes.func,
  onMuteStatusChange: _react2.default.PropTypes.func,
  onVolumeLevelChange: _react2.default.PropTypes.func,
  onFullScreenEnter: _react2.default.PropTypes.func,
  onFullScreenExit: _react2.default.PropTypes.func,
  wrapperElement: _react2.default.PropTypes.object
};
VideoPlayerWrapper.defaultProps = {
  onMuteStatusChange: _noop3.default,
  onFullScreenEnter: _noop3.default,
  onFullScreenExit: _noop3.default,
  onVolumeLevelChange: _noop3.default
};
exports.default = VideoPlayerWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/video-player-react/dist/src/video-player/video-player.js
// module id = 2759
// module chunks = 66